// Human-readable labels for routes — used by the history back button to name
// the page you were previously on.

const STATIC_LABELS: Record<string, string> = {
  '/': 'Home',
  '/wardrobe': 'Wardrobe',
  '/wardrobe/add': 'Add Item',
  '/fits': 'Fits',
  '/fits/available': 'Available Fits',
  '/fits/builder': 'Fit Builder',
  '/fits/builder/sessions': 'Fit Builder',
  '/fits/today': 'What to Wear Today',
  '/fits/add': 'Add Fit',
  '/fits/timeline': 'Timeline',
  '/fits/planner': 'Planner',
  '/fits/planner/new': 'New Plan',
  '/before-buy': 'Before You Buy',
  '/before-buy/ai-suggestions': 'AI Suggestions',
  '/before-buy/gap-report': 'Gap Report',
  '/camera': 'Camera',
  '/search': 'Search',
  '/profile': 'Profile',
  '/profile/account': 'Account',
  '/profile/closets': 'Closets',
  '/profile/sizes': 'My Sizes',
  '/profile/stores': 'My Stores',
  '/profile/designers': 'My Designers',
  '/profile/style': 'Style Profile',
  '/profile/services': 'Service Providers',
  '/profile/archive/wishlist': 'Wishlist Archive',
};

export function labelForPath(pathname: string, search = ''): string {
  // The items list label depends on its filter.
  if (pathname === '/wardrobe/items') {
    const p = new URLSearchParams(search);
    if (p.get('unworn') === '1') return 'Unworn Items';
    switch (p.get('status')) {
      case 'wishlist':
        return 'Wishlist';
      case 'in-closet':
        return 'In Closet';
      case 'out-for-service':
        return 'Out for Service';
      case 'pending-delivery':
        return 'Pending Delivery';
      case 'wishlist-archive':
        return 'Wishlist Archive';
      case 'for-sale':
        return 'For Sale';
      case 'archived':
        return 'Archived';
      default:
        return 'Items';
    }
  }

  if (STATIC_LABELS[pathname]) return STATIC_LABELS[pathname];

  // Dynamic routes.
  if (/^\/wardrobe\/item\//.test(pathname)) return 'Item';
  if (/^\/fits\/[^/]+\/version\//.test(pathname)) return 'Version';
  if (/^\/fits\/[^/]+\/wear\//.test(pathname)) return 'Wear';
  if (/^\/fits\/planner\/[^/]+$/.test(pathname)) return 'Plan';
  if (/^\/fits\/[^/]+$/.test(pathname)) return 'Fit';
  if (/^\/profile\/closets\/[^/]+$/.test(pathname)) return 'Closet';

  return 'Back';
}
